import { from } from 'rxjs';

export default class ElasticSearchConstants {
    // Elastic search document type and index 
    static ES_DOC_TYPE = 'document';
    static ES_DOC_INDEX = 'cfdocument';

    // Elastic search item type and index 
    static ES_ITM_TYPE = 'items';
    static ES_ITM_INDEX = 'cfitems';

    // Elastic search association type and index 
    static ES_ASSOC_TYPE = 'associations';
    static ES_ASSOC_INDEX = 'cfassociations';

    // Elastic search projects type and index 
    static ES_PROJ_TYPE = 'projects';
    static ES_PROJ_INDEX = 'cfprojects';
    static FLTR_TYP_NODE = 'node_type_id';
    static FLTR_TYP_UPDTON = 'update_on';
    static FLTR_TYP_DOC = 'document_id';
    static FLTR_TYP_ADOPT = 'adoption_status';
    static FLTR_TYP_ASSOC= 'item_association_type';
    static FLTR_TYP_UPDTBY = 'updated_by';
    static FLTR_TYP_ID = 'identifier';
    static FLTR_TYP_PROJID = 'project_id';
    static FLTR_TYP_WORKFID = 'project_workflow_id';
    static FLTR_TYP_TXNMYID = 'taxonomy_id';
    static FLTR_KEYWORD = 'keyword';
    static FLTR_KEY_NODE_TYPE_ID = 'nodeType.keyword';
    static FLTR_KEY_CFITEMTYPEURI = 'CFItemTypeURI.title.keyword';
    static PROJECT_WORKFLOW_KEYWORD = 'project_workflow_id.keyword';
    static WORKFLOW_KEYWORD = 'workflow_id.keyword';
    static UPDATED_BY_KEYWORD ='updatedBy.keyword';
    static ASSOCIATION_KEYWORD = 'associationType.keyword';
    static ASSOCIATION_KEYWORD_ITEMS = 'association_type';
    static ADOPTION_STATUS_KEYWORD = 'adoptionStatus.keyword'
    static CFPACKAGEURI_KEYWORD = 'CFPackageURI.identifier.keyword';
    static LAST_CHANGE_DATE_KEYWORD = 'lastChangeDateTime';
    static THIRTY_DAY_KEY = "last_thirty_days";
    static SEVEN_DAY_KEY = "last_seven_days";
    static THIRTY_DAY_VALUE = 30;
    static SEVEN_DAY_VALUE = 7;
    static assocUniqueKey = {"originNodeURI":"originNodeURI.identifier.keyword"};
    static assocCollapseValue = "originNodeURI.identifier.keyword";
}